import React from 'react';
import styled from 'styled-components';

//CORE COMPOENTNS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerGutter, 
    ContainerWrap, 
    ContainerPadding 
} from '../../../components-core/packages/components-core/dist/container/index';

//STYLE
import { Text, TextAppearance, WhiteSpace } from '../../../components-core/packages/components-core/dist/text';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button'


const FullSizeContainer = styled.div`
    height: 100vh;
    width: 100vw;
`;

const TopContainer = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: flex-end;
    position: absolute;
    overflow: hidden;

    z-index: 1;
`;

const BackgroundImageContainer = styled.div`
    height: 100vh;
    width: 100vw;
    background-image: url(${props => props.backgroundImageUrl && props.backgroundImageUrl});
    background-position: center;
    background-size: cover;
    background-blend-mode: overlay;
    object-fit: cover;

    ${props => !props.backgroundImageUrl &&
        `
            background: rgb(0,67,122);
            background: -moz-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: -webkit-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            background: linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00437a",endColorstr="#001e50",GradientType=1);
        `
    }
`;

const GeneralContainer = styled.div`
    z-index: 1;
    position: relative;
`;

const BackgroundVideo = styled.video`
    height: 100vh;
    width: 100vw;

    object-fit: cover;
`;


class Experience extends React.Component {

    constructor() {
        super();
        this.state = {
            isVideoPromo: false
        }
    }
    renderExperienceText(){
        const {custom5} = this.props;
        if(custom5 == 1){
            return(
                <Text appearance={TextAppearance.copy300}>*Caddy Style modelinin örnek iç tasarımıdır.</Text>
            )
        }else {
            return (
                <Text appearance={TextAppearance.copy300}></Text>
            )
        }
    }


    renderTextContainer() {
        const { custom1, custom2} = this.props;

        return (
            <Container wrap={ContainerWrap.always} >
                <Text appearance={TextAppearance.headline0450} whiteSpace={WhiteSpace.preLine} >
                    {custom1 + '\n'}
                    <Text bold>
                        {custom2}
                    </Text>
                </Text>
                {this.renderExperienceText()}
            </Container>
        )
    }

   
    renderVideoBackground() {
        return (
            <FullSizeContainer>
                <BackgroundVideo autoPlay muted loop>
                    <source src="https://s7g10.scene7.com/is/content/volkswagenag/Video_home_v4.1-0x720-3000k" type="video/mp4"/>
                </BackgroundVideo>
            </FullSizeContainer>

        )
    }

    render() {
        const { custom, custom3, custom4 } = this.props;

        return (
            <ThemeProvider theme={'image'}>
                <GeneralContainer>
                    <TopContainer>
                        <Container 
                            wrap={ContainerWrap.always} 
                            padding={containerPadding}
                            gutter={ContainerGutter.dynamic0200}
                        >
                            {this.renderTextContainer()}
                            <Button 
                                appearance={ButtonAppearance.Primary} 
                                onClick={() => window.open(custom4, '_blank')}
                            >
                                {custom3 ? custom3 : '360° bakışı deneyimle'}
                            </Button>
                        </Container>
                    </TopContainer>
                </GeneralContainer>
                    
                {
                    this.state.isVideoPromo ? 
                    this.renderVideoBackground() : 
                    <BackgroundImageContainer backgroundImageUrl={custom ? custom : null} />
                }
            </ThemeProvider>
        )
    }
}

const containerPadding = {
    left: ContainerPadding.dynamic0300,
    right: ContainerPadding.dynamic0300,
    bottom: ContainerPadding.dynamic0450
}


export default Experience;